import bfLogo from "@assets/logos/bf-landing.svg";
import FavIcon from "@assets/favicons/favicon.png";
import instagramIcon from "@assets/icons/new-instagram.svg";
import facebookIcon from "@assets/icons/new-facebook.svg";
import mailIcon from "@assets/icons/new-mail.svg";
import CheckmarkIcon from "@assets/icons/usp-check-mark.svg";
import Paper from "@assets/icons/paper.svg";

import { IPlatformSpecificInfo } from "../platform";

export const landingPagePlatform: IPlatformSpecificInfo = {
  id: 8,
  currency: "GBP",
  name: "Black Friday Expert",
  abbreviation: "landing",
  country: "United Kingdom",
  domain: "blackfriday.expert",
  merchantOverviewLink: "/stores/",
  dealOverviewLink: "/deals/",
  urlAddition: "",
  isLandingPage: false,
  defaultBackButtonText: "Back",
  breadcrumbHomeName: "Home",
  breadcrumbHomeUrl: "/",
  readingTimeText: {
    singular: "minute readingtime",
    plural: "minutes readingtime"
  },
  newsletterButtonTitle: "Subscribe",
  newsletterModalTitle: "Subscribe to newsletter",
  fallBackHeaderImage: "https://media.blackfridaynederland.nl/wordpress/20200430114412/default-blog-image-be.jpg",
  bottomFooter: {
    items: [
      {
        title: "Contacter",
        url: "/fr/contacter/"
      },
      {
        title: "Privacy",
        url: "/fr/privacy/"
      },
      {
        title: "Cookies",
        url: "/fr/cookies/"
      },
      {
        title: "Sitemap",
        url: "/fr/sitemap/"
      }
    ],
    logo: {
      src: bfLogo,
      alt: "",
      title: ""
    },
    logoLink: "/uk/"
  },
  middleFooter: {
    links: [
      {
        id: "TRENDING_BLOCK",
        title: "More about Black Friday",
        links: []
      },
      {
        id: "SHOPS_BLOCK",
        title: "Most viewed pages",
        links: []
      },
      {
        id: "THIRD_BLOCK",
        title: "Stores with the best deals",
        links: []
      }
    ],
    newsletter: {
      title: "Subscribe to the newsletter",
      text: "and receive the best deals",
      buttonText: "Newsletter",
      buttonIcon: Paper
    },
    socialMedia: {
      id: "SOCIAL_BLOCK",
      title: "Follow us",
      socialItem: [
        {
          image: {
            src: facebookIcon,
            alt: "",
            title: ""
          },
          link: "https://www.facebook.com/BlackFridayUnitedKingdom/"
        },
        {
          image: {
            src: instagramIcon,
            alt: "",
            title: ""
          },
          link: "https://www.instagram.com/blackfridayexpert_uk/"
        },
        {
          link: "info@blackfriday.expert",
          image: {
            src: mailIcon,
            alt: "",
            title: ""
          }
        }
      ]
    }
  },
  fallbackMerchantHeader: {
    src: "https://media.blackfridaynederland.nl/wordpress/20200421102650/Black-Friday-Winkels-Nederland.jpg",
    alt: "Store header",
    title: "Header storepage"
  },
  logo: {
    src: bfLogo,
    alt: "Black Friday Logo",
    title: "Black Friday Logo"
  },
  uspModule: {
    uniqueSellingPoints: [
      {
        icon: CheckmarkIcon,
        link: {
          url: "/uk/stores/",
          title: "All promotions in one overview"
        }
      },
      {
        icon: CheckmarkIcon,
        link: {
          url: "/uk/deals/",
          title: "Easily score the best deals"
        }
      },
      {
        icon: CheckmarkIcon,
        link: {
          url: "/uk/black-friday/",
          title: "Don't miss out on Black Friday"
        }
      }
    ]
  },
  storeTabs: [],
  dealTabs: [],
  locale: "en",
  tagManagerScriptLocation: "/static/googletagmanager-landing.js",
  weCanTrackScriptLocation: "/static/wecantrack-landing.js",
  favIcon: FavIcon,
  favIconPublic: "https://media.blackfridaynederland.nl/static/FavIcons/favicon-bf-expert-int.png",
  gtm: "GTM-5KG6LNX",
  enableDealAlerts: false,
  isOffline: true
};
